export async function initializeCamera(vm) {
  const ua = navigator.userAgent;

  const isFirefox = /firefox/i.test(ua);

  if (isFirefox) {
    await initializeCameraFirefox(vm);
  } else {
    await initializeCameraBrowserAndMobile(vm);
  }
}

export function closeCamera(vm) {
  if (vm.stream ) {
    vm.stream .getTracks().forEach(track => {
      track.stop();
    });
    vm.stream  = null;
    console.log('Camera closed');
  } else {
    console.log('No camera to close');
  }
}


export async function initializeCameraBrowserAndMobile(vm) {
  vm.cameraReady = false;
  vm.cameraError = null;

  const timeout = setTimeout(() => {
    if (!vm.cameraReady) {
      vm.cameraError = "Impossible d'accéder à la caméra dans le délai imparti. Veuillez vérifier les permissions.";
    }
  }, 10000);

  try {
    const tempStream = await navigator.mediaDevices.getUserMedia({ video: true });
    tempStream.getTracks().forEach(t => t.stop());

    const devices = await navigator.mediaDevices.enumerateDevices();
    const cameras = devices.filter(d => d.kind === "videoinput");
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (!cameras.length) {
      vm.cameraError = "Aucune caméra détectée sur cet appareil.";
      clearTimeout(timeout);
      return;
    }

    const rearCamera = cameras.find(c =>
      c.label.toLowerCase().includes("back") ||
      c.label.toLowerCase().includes("rear") ||
      c.label.toLowerCase().includes("environment")
    ) || cameras[0];

    const constraints = isIOS
      ? { video: { facingMode: { ideal: "environment" } }, audio: false }
      : { video: { deviceId: { exact: rearCamera.deviceId } }, audio: false };

    vm.stream = await navigator.mediaDevices.getUserMedia(constraints);

    const video = vm.$refs.videoElement;
    video.srcObject = vm.stream;
    await video.play();

    vm.cameraReady = true;
    clearTimeout(timeout);

  } catch (err) {
    clearTimeout(timeout);
    handleCameraError(vm, err);
  }
}



export async function initializeCameraFirefox(vm) {
  vm.cameraReady = false;
  vm.cameraError = null;

  const timeout = setTimeout(() => {
    if (!vm.cameraReady) {
      vm.cameraError =
        "Impossible d'accéder à la caméra dans le délai imparti. Veuillez vérifier les permissions.";
    }
  }, 10000);

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });

    const devices = await navigator.mediaDevices.enumerateDevices();
    const cameras = devices.filter(d => d.kind === "videoinput");

    if (!cameras.length) {
      vm.cameraError = "Aucune caméra détectée sur cet appareil.";
      clearTimeout(timeout);
      return;
    }

    const rearCamera =
      cameras.find(c =>
        c.label.toLowerCase().includes("back") ||
        c.label.toLowerCase().includes("rear") ||
        c.label.toLowerCase().includes("environment")
      ) || cameras[0];

    const currentDeviceId = stream.getVideoTracks()[0]?.getSettings().deviceId;
    if (currentDeviceId !== rearCamera.deviceId) {
      stream.getTracks().forEach(t => t.stop());

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const constraints = isIOS
      ? { video: { facingMode: { ideal: "environment" } }, audio: false }
      : { video: { deviceId: { exact: rearCamera.deviceId } }, audio: false };

    vm.stream = await navigator.mediaDevices.getUserMedia(constraints);

    } else {
      vm.stream = stream;
    }

    const video = vm.$refs.videoElement;
    video.srcObject = vm.stream;

    video.onloadedmetadata = () => {
      video.play();
      vm.cameraReady = true;
      clearTimeout(timeout);
    };

  } catch (err) {
    clearTimeout(timeout);

    if (err.name === "NotAllowedError") {
      vm.cameraError =
        "Vous avez refusé l'accès à la caméra. Veuillez autoriser l'accès dans les paramètres du navigateur et rafraîchir la page.";
    } else if (err.name === "NotFoundError") {
      vm.cameraError = "Aucune caméra disponible sur cet appareil.";
    } else if (err.name === "AbortError" || err.name === "NotReadableError") {
      vm.cameraError =
        "La caméra est utilisée par une autre application ou l'accès a été interrompu.";
    } else {
      vm.cameraError =
        "Impossible d'accéder à la caméra. Vérifiez les permissions, utilisez HTTPS et rafraîchissez la page.";
    }

    vm.cameraReady = false;
  }
}


function handleCameraError(vm, err) {
  if (err.name === "NotAllowedError") {
    vm.cameraError = "Vous avez refusé l'accès à la caméra. Veuillez autoriser l'accès dans les paramètres du navigateur.";
  } else if (err.name === "NotFoundError") {
    vm.cameraError = "Aucune caméra disponible sur cet appareil.";
  } else if (err.name === "OverconstrainedError") {
    vm.cameraError = "Impossible de sélectionner la caméra souhaitée. Essayez un autre appareil ou navigateur.";
  } else {
    vm.cameraError = "Impossible d'accéder à la caméra. Essayez de rafraîchir la page, utiliser un autre navigateur ou vérifier les permissions.";
  }
}

export async function captureImage(vm) {
  const videoElement = vm.$refs.videoElement;
  if (!videoElement) return;

  const canvas = document.createElement("canvas");
  canvas.width = videoElement.videoWidth;
  canvas.height = videoElement.videoHeight;
  canvas.getContext("2d").drawImage(videoElement, 0, 0);

  const imageData = canvas.toDataURL("image/png");

  return imageData;
}


